import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

function Login({ onLogin }) {
    const [clientId, setClientId] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const credentials = btoa(`${clientId}:${clientSecret}`);
            const response = await fetch('/token/oauth', {
                method: 'POST',
                headers: {
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                onLogin(data.access_token);
            } else {
                setError('Login fallito. Controlla le credenziali.');
            }
        } catch (err) {
            setError('Errore di connessione.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50">
            <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-xl p-8">
                <div className="mb-6 text-center">
                    <img src="/azimut-logo.png" alt="Azimut logo" className="h-12 w-auto mx-auto mb-4" />
                    <h1 className="text-2xl font-bold text-slate-800">Login</h1>
                    <p className="text-slate-600">Inserisci le credenziali per accedere</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="clientId" className="block text-sm font-medium text-slate-700">
                            Client ID
                        </label>
                        <input
                            type="text"
                            id="clientId"
                            value={clientId}
                            onChange={(e) => setClientId(e.target.value)}
                            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="clientSecret" className="block text-sm font-medium text-slate-700">
                            Client Secret
                        </label>
                        <input
                            type="password"
                            id="clientSecret"
                            value={clientSecret}
                            onChange={(e) => setClientSecret(e.target.value)}
                            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            required
                        />
                    </div>

                    {error && (
                        <div className="rounded-md bg-red-50 p-3 text-sm text-red-600">
                            {error}
                        </div>
                    )}

                    <Button type="submit" className="w-full justify-center" disabled={isLoading}>
                        {isLoading ? 'Accesso in corso...' : 'Accedi'}
                    </Button>
                </form>
            </div>
        </div>
    );
}

Login.propTypes = {
    onLogin: PropTypes.func.isRequired,
};

export default Login;
